import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ElectroControlScope, ElectroInstallationBuliding, ElectroCourseOverview, ElectroFireAlarmSystem, ElectroEmergencyLightSystem, ElectroDistributionOverview, ElectroRiskAssessment, ElectroDocumentAssessment, ElectroFormTemplates } from '../models/electroinstallation';
import { ElectroInstallationService } from './electro-installation.services';
import { MeasureProtocolService } from 'src/app/kuba/measure-protocol/services/measure-protocol.services';


@Injectable()
export class InstallationBuildingsResolver{
    constructor(private backend: ElectroInstallationService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<ElectroInstallationBuliding[]> {
        return this.backend.getContractBuildings(+route.parent.parent.params['cid']);
    }
}
@Injectable()
export class ControlScopeResolver {
    constructor(private backend: ElectroInstallationService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<ElectroControlScope> {
        return route.params['id'] > 0 ?
            this.backend.getControlScopeById(+route.params['id']) : null;
    }
}
@Injectable()
export class DocumentAssessmentResolver {
    constructor(private backend: ElectroInstallationService){}
    resolve(route: ActivatedRouteSnapshot): Observable<ElectroDocumentAssessment> {
        return route.params['id'] > 0 ? 
          this.backend.getDocumentAssessmsentById(+route.params['id']) : null;
    }
}

@Injectable()
export class CourseOverviewResolver {
    constructor(private backend: ElectroInstallationService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<ElectroCourseOverview> {
        return route.params['id'] > 0 ?
         this.backend.getCourseById(+route.params['id']) : null;
    }
}

@Injectable()
export class DistributionsOverviewResolver {
    constructor(private backend: ElectroInstallationService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<ElectroDistributionOverview> {
        return route.params['id'] > 0 ?
         this.backend.getDistributionsById(+route.params['id']) : null;
    }
}

@Injectable()
export class EmergencyLightingResolver {
    constructor(private backend: ElectroInstallationService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<ElectroEmergencyLightSystem> {
        return route.params['id'] > 0 ?
         this.backend.getEmergencyLightingById(+route.params['id']) : null;
    }
}


@Injectable()
export class FireAlarmSystemResolver {
    constructor(private backend: ElectroInstallationService){}
    resolve(route: ActivatedRouteSnapshot): Observable<ElectroFireAlarmSystem> {
         return route.params['id'] > 0 ? 
         this.backend.getFirealarmSystemById(+route.params['id']) : null;
    }
}

@Injectable()
export class RiskAssessmentResolver {
    constructor(private backend: ElectroInstallationService){}
    resolve(route: ActivatedRouteSnapshot): Observable<ElectroRiskAssessment> {
         return route.params['id'] > 0 ? 
         this.backend.getRiskAssessmentById(+route.params['id']) : null; 
    }
}

@Injectable()
export class FormsWithTemplateResolver {
    constructor(private backend: ElectroInstallationService){}
    resolve(route: ActivatedRouteSnapshot): Observable<any> {
         return +route.parent.params['Id'] > 0 ? 
         this.backend.getEnabledFormsWithTemplate(+route.parent.params['Id']) : null; 
    }
}

@Injectable()
export class ElectroBusinessInstTypeResolver {
    constructor(private backend: MeasureProtocolService){}
    resolve(route: ActivatedRouteSnapshot): Observable<any> {
         return this.backend.getElectroBusinessInstrumentTypes(); 
    }
}

@Injectable()
export class ElectroBusinessInstModelResolver {
    constructor(private backend: MeasureProtocolService){}
    resolve(route: ActivatedRouteSnapshot): Observable<any> {
         return this.backend.getElectroBusinessInstrumentModels(); 
    }
}
@Injectable()
export class ElectroBusinessInstrumentsResolver {
    constructor(private backend: MeasureProtocolService){}
    resolve(route: ActivatedRouteSnapshot): Observable<any> {
         return this.backend.getElectroBusinessInstruments(); 
    }
}